goog.provide("shadow.js.shim.module$$carbon$icons_react$es$User$default");
shadow.js.shim.module$$carbon$icons_react$es$User$default = shadow.js.require(377, {}).default;
